import React from 'react';
import TimelineItem from '../timelineItem';

const SideInitiativesSection = () => {
  return (
    <div className="flex flex-col gap-2 px-4">
      <TimelineItem
        title="Technical & Public Relations"
        subtitle="FSR AI"
        dateFrom="2025"
        dateTo="2026"
        liItems={[
          'Served as the Technical and Public Relations lead for FSR AI, where I built and maintained the official website, designed the Student Guide, and managed social media campaigns. I also organized and conducted university events, making a meaningful impact by fostering a connected and informed community for AI students.',
        ]}
        className="pb-6 border-b"
      />
      <TimelineItem
        title="UI UX Community"
        subtitle="Organizer"
        dateFrom="2022"
        dateTo="2024"
        liItems={[
          'Organized monthly meetups, workshops, and webinars for a global community of over 1,000 designers, providing a collaborative platform to connect, learn, and grow together with Figma. This initiative allowed me to make a meaningful impact by fostering international collaboration, sharing valuable design insights, and helping creatives from all over the world develop new skills.',
        ]}
        className="pb-6 border-b"
      />
      <TimelineItem
        title="Graduate Software Engineer"
        subtitle="Cobblestone Energy"
        dateFrom="2022"
        liItems={[
          'Attended a one-week graduate trainee program at Cobblestone, which was fully funded by the company. The program included training on the European electricity market, including how trades occur and how traders and brokers earn a profit. The experience was highly informative, providing insight not only into the field but also in data analytics and its applications.',
        ]}
        className="pb-6 border-b"
      />
      <TimelineItem
        title="Student Expert"
        subtitle="Postman"
        dateFrom="2021"
        dateTo="2022"
        liItems={[
          'Participated as a Student Expert for Postman, dedicating my time to deepen my technical knowledge and become a respected member of the developer community. This experience provided me with the opportunity to sharpen my technical skills, collaborate with passionate developers, and grow my career in software development.',
        ]}
        className="pb-6 border-b"
      />
      <TimelineItem
        title="Alpha Student Ambassador"
        subtitle="Microsoft Learn Student Ambassadors"
        dateFrom="2020"
        dateTo="2022"
        liItems={[
          "Honored to serve as an Alpha Microsoft Student Learn Ambassador during my Bachelors degree. In this role, I got to share my love for technology and help others discover the power of Microsoft's learning resources. I have had the opportunity to connect with students and educators to provide guidance and inspire others to pursue their passions in technology.",
        ]}
        className="pb-2"
      />
    </div>
  );
};

export default SideInitiativesSection;
